import { render, staticRenderFns } from "./quesDetail.vue?vue&type=template&id=48afa446&scoped=true&"
import script from "./quesDetail.vue?vue&type=script&lang=js&"
export * from "./quesDetail.vue?vue&type=script&lang=js&"
import style0 from "./quesDetail.vue?vue&type=style&index=0&id=48afa446&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48afa446",
  null
  
)

export default component.exports